// biome-ignore lint/style/noExportedImports: we need to configure i18next before exporting
import i18next, { type i18n } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector/cjs";
import { initReactI18next } from "react-i18next/initReactI18next";
import enTranslations from "./locales/en/translation";
import esTranslations from "./locales/es/translation";

const fallbackLng: i18n["language"] = "en";
const defaultNS = "translation";
export const languages: i18n["languages"] = [fallbackLng, "es"];

const IS_DEV = import.meta.env.DEV;

export const resources = {
	en: {
		translation: enTranslations,
	},
	es: {
		translation: esTranslations,
	},
} as const;

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: IS_DEV,
		supportedLngs: languages,
		fallbackLng,
		interpolation: { escapeValue: false },
		fallbackNS: defaultNS,
		defaultNS,
		detection: {
			order: ["localStorage"],
		},
		resources,
	});

export default i18next;
